export const CONTACT = {
  location: "Belgrade, Serbia",
  email: "nedeljkopopovic94@gmail.com",
  mapCenter: [44.8234288, 20.4100497],
  markerAnchor: [44.8228288, 20.4030997],
};
